export function slugy(name) {
  if (!name) return '';

  return name
    .toLowerCase()                          
    .normalize('NFD')                      
    .replace(/[\u0300-\u036f]/g, '')     
    .replace(/[^\p{L}\p{N}\s-]+/gu, '')     
    .replace(/\s+/g, '-')                  
    .replace(/-+/g, '-')                  
    .trim();                               
}
